import { useEffect } from 'react';
import type { ShortTermCreditLimitSummary } from 'src/apis/contract-management/types';
import { useAxios } from 'src/hooks/use-axios';

type HookConfig = {
  url: string;
};

export function useShortTermCreditLimitSummary({ url }: HookConfig) {
  const request = useAxios(
    (axios, baseConfig) =>
      axios.request<ShortTermCreditLimitSummary>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    request.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return request;
}

export type ShortTermCreditLimitSummaryRequest = ReturnType<
  typeof useShortTermCreditLimitSummary
>;

type OptionalHookConfig = {
  url?: string;
};

type ExecuteProps = {
  url: string;
};

export function useOptionalShortTermCreditLimitSummary({
  url,
}: OptionalHookConfig) {
  const request = useAxios(
    (axios, baseConfig, { url }: ExecuteProps) =>
      axios.request<ShortTermCreditLimitSummary>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!url) return;
    request.execute({ url });
    // oxlint-disable-next-line exhaustive-deps
  }, [url]);

  if (!url) return;

  return request;
}

export type OptionalShortTermCreditLimitSummaryRequest = ReturnType<
  typeof useOptionalShortTermCreditLimitSummary
>;
